export enum PRICE_TYPE {
    TODAY = 'IMMEDIAT',
    MONTHLY = 'MENSUEL',
    DEFERRED = 'DIFFERE',
    OTHER = 'AUTRE',
}
